import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';
import { getDocumentsV2 } from '../redux/documentActions';

type UseGetDocumentsProps = {
  societyId?: string;
  folderId?: string;
  page?: number;
  itemsPerPage?: number;
  refetchKey?: number;
};

export const useGetDocuements = ({
  societyId,
  folderId,
  page = 1,
  itemsPerPage = 10,
  refetchKey,
}: UseGetDocumentsProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchDocuments = useCallback(
    async (controller: AbortController) => {
      if (!societyId) return;

      try {
        setIsLoading(true);

        await store.dispatch(
          getDocumentsV2({
            societyId,
            folderId,
            params: {
              page,
              items: itemsPerPage,
            },
          })
        );

        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page, itemsPerPage, societyId, folderId, refetchKey]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchDocuments(controller);

    return () => controller.abort();
  }, [fetchDocuments]);

  return {
    isLoading,
    isError,
  };
};
